import React from "react";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { FilterOption } from "../FilterPopover.types.ts";
import SubMenuList from "./SubMenuList.tsx";
import { GetBooleanData } from "./SubMenuDataHelper.ts";

export interface BooleanSubMenuProps {
    selectedOption: FilterOption;
    onChange: (value: boolean | undefined) => void;
    onLeftArrowClick?: () => void;
    submenuInputRef: React.RefObject<HTMLInputElement>;
}

function BooleanSubMenu(props: BooleanSubMenuProps) {
    const { onChange, onLeftArrowClick, selectedOption, submenuInputRef } = props;
    const { translateString } = useTranslation();

    const value = GetBooleanData(selectedOption.value);

    const data =
        selectedOption.fixedData && selectedOption.fixedData.length > 0
            ? selectedOption.fixedData
            : [
                  { id: "1", name: translateString("yes") },
                  { id: "0", name: translateString("no") },
              ];

    const onSelectOption = (id: string) => {
        if (value === id) {
            onChange(undefined);
        } else {
            onChange(id === "1" ? true : false);
        }
    };

    return (
        <SubMenuList
            submenuInputRef={submenuInputRef}
            data={data}
            onChange={(chosenOption) => onSelectOption(chosenOption.id)}
            onLeftArrowClick={onLeftArrowClick}
            chosenValues={value ? [data.find((x) => x.id == value)!] : []}
        />
    );
}

export default BooleanSubMenu;
